/** @format */

import { AiFillHeart, AiFillMessage, AiFillShopping } from "react-icons/ai";
import { FaWhatsapp } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { address, email, phone, socialLinks } from "../utils/utils";

const Footer = () => {
  // const dispatch = useDispatch();
  const { customerInfo } = useSelector((state) => state.auth);

  // console.log('customer Info id', customerInfo.id)

  const { card_total } = useSelector((state) => state.card);
  const { wishList_count } = useSelector((state) => state.card);
  const { totalCustommerUnread } = useSelector((state) => state.chat);
  const navigate = useNavigate();

  const redirect_to_card_page = () => {
    if (customerInfo) {
      //navigate(`/card/${customerInfo.id}`);
      navigate(`/card`);
    } else {
      navigate("/login");
    }
  };

  const redirect_to_wishlist_page = () => {
    if (customerInfo) {
      navigate(`/dashboard/my_wishlist`);
    } else {
      navigate("/login");
    }
  };

  const redirect_to_chat_page = () => {
    if (customerInfo) {
      navigate(`/dashboard/my_chats`);
    } else {
      navigate("/login");
    }
  };

  const displayText =
    "GOBYMALL est une plateforme digitale de mise en relation entre vendeurs et acheteurs. La plateforme ne gère ni les paiements ni les livraisons.";

  return (
    <footer className='bg-[#000031] text-light py-3'>
      <div className='w-[95%] flex flex-wrap mx-auto border-b md-lg:pb-10 sm:pb-6 bottom-4'>
        <div className='w-3/12 lg:w-4/12 sm:w-full'>
          <div className='flex flex-col sm:w-full gap-3'>
            <Link
              to='/'
              className='w-[190px] h-[50px] flex items-center justify-center bg-orange-500 mb-4 rounded-md px-2'
            >
              <img
                className='w-[50px] h-[50px]'
                src='/images/logo.png'
                alt='Logo'
              />
              <span className='text-white text-2xl font-bold ml-2 2xs:hidden'>
                GOBYMALL
              </span>
            </Link>
            <ul className='flex flex-col justify-start items-start gap-2 text-gray-600'>
              <li>{address}</li>
              <li>
                <a
                  href={`https://wa.me/${phone}`}
                  className='flex items-center gap-2   rounded'
                >
                  <FaWhatsapp /> +{phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${email}`}>{email}</a>
              </li>
            </ul>
          </div>
        </div>
        <div className='w-5/12 lg:w-8/12 sm:w-full'>
          <div className='flex justify-center sm:justify-start sm:mt-6 w-full'>
            <div className='m-4'>
              <h2 className='font-bold text-lg mb-2 text-gray-400'>
                Usefull links
              </h2>
              <div className='flex justify-between items-start gap-[80px] text-gray-400 lg:gap-[40px]'>
                <ul className='flex flex-col gap-2 '>
                  <li>
                    <Link
                      to='/about'
                      className='text-gray-600 hover:text-white transition duration-300 '
                    >
                      A Propos de NOUS
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/contact'
                      className='text-gray-600 hover:text-white transition duration-300 '
                    >
                      Nous contact
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='#'
                      className='text-gray-600 hover:text-white transition duration-300 '
                    >
                      Conditions d'utilisation'
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='#'
                      className='text-gray-600 hover:text-white transition duration-300 '
                    >
                      Confidantialité
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='#'
                      className='text-gray-600 hover:text-white transition duration-300 '
                    >
                      Delivery Information
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='#'
                      className='text-gray-600 hover:text-white transition duration-300 '
                    >
                      Blogs
                    </Link>
                  </li>
                </ul>

                {/* <ul className='flex flex-col gap-2 '>
                            <li>
                                <Link to='/about' className='text-gray-600 hover:text-white transition duration-300 '>
                                    Who we are
                                </Link>
                            </li>
                            <li>
                                <Link to='/shopInfo' className='text-gray-600 hover:text-white transition duration-300 '>
                                    our services
                                </Link>
                            </li>
                             <li>
                                <Link to='/shopInfo' className='text-gray-600 hover:text-white transition duration-300 '>
                                    About Our Shop
                                </Link>
                            </li>
                             <li>
                                <Link to='/blog' className='text-gray-600 hover:text-white transition duration-300 '>
                                    Our siteMap
                                </Link>
                            </li>
                            <li>
                                <Link to='/delivery' className='text-gray-600 hover:text-white transition duration-300 '>
                                    Projects
                                </Link>
                            </li>
                           
                            <li>
                                <Link to='/blog' className='text-gray-600 hover:text-white transition duration-300 '>
                                    Innovation
                                </Link>
                            </li>
                            <li>
                                <Link to='/blog' className='text-gray-600 hover:text-white transition duration-300 '>
                                    Testimonials
                                </Link>
                            </li>
                        </ul> */}
              </div>
            </div>
            <div className='m-4 w-[60%]'>
              <h2 className='font-bold text-lg mb-2 text-gray-400'>
                Infos Importantes
              </h2>
              <p className='text-slate-600 text-justify leading-relaxed'>
                {displayText}
              </p>
            </div>
          </div>
        </div>
        <div className='w-4/12 lg:w-full lg:mt-6'>
          <div className='w-full flex flex-col justify-start gap-5'>
            <h2 className='font-bold text-lg mb-2 text-gray-400'>
              Joins Our Newsletter Now
            </h2>
            <span className='text-gray-600'>
              Get Email updates about our latest news, offers and more
            </span>
            <div className='h-[50px] w-full bg-white border relative'>
              <input
                type='text'
                placeholder='Enter Your Mail'
                className='h-full bg-transparent w-full px-3 outline-0'
              />
              <button className='h-full absolute right-0 bg-indigo-500 text-white uppercase px-4 font-bold text-sm'>
                Subscribe
              </button>
            </div>
            <ul className='flex justify-start items-center gap-3'>
              {socialLinks.map(({ icon, label, href }, i) => (
                <a
                  key={i}
                  href={href}
                  aria-label={label}
                  className='w-[38px] h-[38px] hover:bg-[#7fad39] hover:text-white flex justify-center items-center
                           bg-white rounded-full'
                >
                  {icon}
                </a>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className='w-[85%] justify-center items-center sm:justify-start sm:items-start sm:text-sm flex flex-wrap py-5 text-center mx-auto'>
        <span className='text-red-600 '>
          CopyRight {new Date().getFullYear()} &copy; All rights reserved by
          @GOBYMALL
          <span className='text-indigo-500 '> Made By NONZOOU MAGNOUDEWA</span>
        </span>
      </div>
      <div className='hidden fixed md-lg:block w-[50px] bottom-3 h-[150px] right-2 bg-white rounded-full p-2'>
        <div className='w-full h-full flex gap-2 flex-col justify-center items-center '>
          <div
            onClick={redirect_to_wishlist_page}
            className='relative flex justify-center items-center cursor-pointer w-[35px] h-[35px]
                rounded-full bg-[#e2e2e2]'
          >
            <span className='text-red-500'>
              <AiFillHeart />
            </span>
            {wishList_count !== 0 && (
              <div
                className='w-[20px] h-[20px] absolute bg-green-500 rounded-full text-white flex justify-center items-center
                -top-[3px] -right-[5px]'
              >
                {wishList_count}
              </div>
            )}
          </div>
          <div
            onClick={redirect_to_card_page}
            className='relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]'
          >
            <span className='text-blue-500'>
              <AiFillShopping />
            </span>
            {card_total !== 0 && (
              <div
                className='w-auto h-[20px] px-2 absolute bg-orange-500 rounded-full text-white flex justify-center items-center
                    -top-[3px] -right-[5px]'
              >
                {card_total}
              </div>
            )}
          </div>

          <div
            onClick={redirect_to_chat_page}
            className='relative w-[35px] h-[35px] rounded-full bg-[#e2e2e2] flex justify-center items-center cursor-pointer'
          >
            <AiFillMessage className='text-lime-700' />
            {totalCustommerUnread !== 0 && (
              <div className='absolute -top-[3px] -right-[5px] h-[20px] px-2 bg-blue-300 rounded-full text-white flex justify-center items-center'>
                {totalCustommerUnread}
              </div>
            )}
          </div>

          <div className='relative flex justify-center items-center cursor-pointer w-[35px] h-[35px] rounded-full bg-[#e2e2e2]'>
            <a
              href={`https://wa.me/${phone}`}
              className='flex items-center gap-2  text-green-500 rounded'
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
